import { 
  LayoutDashboard, 
  ClipboardList, 
  Sliders, 
  Zap, 
  Shield, 
  Star, 
  QrCode, 
  Bell, 
  User, 
  Settings, 
  Users, 
  Package, 
  Calendar, 
  DollarSign, 
  TrendingUp, 
  CreditCard, 
  Download,
  Workflow 
} from "lucide-react";

/**
 * Navigation structure for DashboardV2
 * SINGLE SOURCE OF TRUTH for sidebar tabs
 * Used by: DashboardV2, RolesTab (for permission checkboxes)
 */
export const navigationGroups = [
  {
    id: 'home',
    label: 'Home',
    icon: LayoutDashboard,
    isStandalone: true
  },
  {
    id: 'operations',
    label: 'Operations',
    icon: Settings,
    items: [
      { id: 'roles', label: 'Roles', icon: Shield },
      { id: 'teamMembers', label: 'Team', icon: Users },
      { id: 'assets', label: 'Assets', icon: Package },
      { id: 'services', label: 'Services', icon: Zap },
      { id: 'schedule', label: 'Bookings', icon: Calendar },
      { id: 'flows', label: 'Flows', icon: Workflow },
    ]
  },
  {
    id: 'financials',
    label: 'Financials',
    icon: DollarSign,
    items: [
      { id: 'revenue', label: 'Revenue', icon: TrendingUp },
      { id: 'payouts', label: 'Payouts', icon: Download },
      { id: 'account', label: 'Account', icon: Settings },
      { id: 'payroll', label: 'Payroll', icon: DollarSign },
    ]
  },
  {
    id: 'customers',
    label: 'Customers',
    icon: ClipboardList,
    items: [
      { id: 'branding', label: 'Branding', icon: Sliders },
      { id: 'waivers', label: 'Waivers', icon: Shield },
      { id: 'reviews', label: 'Reviews', icon: Star },
      { id: 'checkin', label: 'Check-In', icon: QrCode },
      { id: 'leads', label: 'Leads', icon: TrendingUp },
      { id: 'relations', label: 'Relations', icon: User },
    ]
  }
];

/**
 * Get all tab IDs as flat array (for role permissions)
 */
export const getAllTabIds = () => {
  const tabs = [];
  
  navigationGroups.forEach(group => {
    if (group.isStandalone) {
      tabs.push({ id: group.id, label: group.label, group: null });
    } else if (group.items) {
      group.items.forEach(item => {
        tabs.push({ id: item.id, label: item.label, group: group.label });
      });
    }
  });
  
  return tabs;
};

/**
 * Filter navigation based on role permissions
 * @param {Object} tabPermissions - Object like { branding: true, waivers: true }
 * @param {Boolean} isAdmin - If true, show all tabs
 */
export const filterNavigationByPermissions = (tabPermissions = {}, isAdmin = false) => {
  if (isAdmin) {
    return navigationGroups; // Admins see everything
  }
  
  return navigationGroups.map(group => {
    if (group.isStandalone) {
      // Always show home
      return group;
    }
    
    // Filter items based on permissions
    const filteredItems = group.items.filter(item => tabPermissions[item.id] === true);
    
    return {
      ...group,
      items: filteredItems
    };
  }).filter(group => {
    // Remove groups with no items
    if (group.items) {
      return group.items.length > 0;
    }
    return true;
  });
};
